import { primaryColor } from '../../assets/jss/appHealth.style';

const styles = (theme) => ({
  gridChatContainer: {
    height: '100vh',
    overflow: 'hidden',
    display: 'grid',
    position: 'relative',
    gridTemplateColumns: `270px 1fr`,
    gridTemplateRows: '1fr 64px',
    gridTemplateAreas: `
            'sidebar-left content'
            'footer footer'
            `,
    flex: 1,
    '@media (min-width: 700px) and (max-width: 1400px)': {
      height: '100dvh',
      gridTemplateRows: '1fr 64px',
    },
  },
  gridChatContainerClose: {
     gridTemplateColumns: `80px 1fr`,
  },
  drawer: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '1px 0 1px rgba(0, 0, 0, 0.1)',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
    justifyContent: 'space-between',
    maxHeight: 'calc(100% - 64px)',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    '@media (min-width: 700px) and (max-width: 1400px)': {
      height: 'calc(100dvh - 64px)',
      maxHeight: '100%',
    },
  },
  menuButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px',
    fontSize: '12px',
    color: '#505050',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      borderRadius: 0,
    },
  },
  hide: {
    display: 'none',
  },
  sidebarLeft: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '1px 0 1px rgba(0, 0, 0, 0.1)',
    height: '100%',
    overflow: 'hidden',
  },
  sidebarHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'center',
    padding: '16px 24px',
    position: 'sticky',
    top: 0,
    backgroundColor: '#FFF',
    zIndex: 10,
  },
  contactSearchForm: {
    flex: 1,
    width: '100%',
  },
  contactSearch: {
    flex: 1,
    border: 'none',
    backgroundColor: '#F2F2F2',
    borderRadius: '8px',
  },
  tabSelectorCustomized: {
    width: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    // height: '100%',
  },
  contentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '0 24px',
  },
  selectedContact: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  title: {
    fontSize: '20px !important',
    color: primaryColor,
    fontWeight: 700,
  },
  sideBarTitle: {
    fontSize: '18px !important',
    color: primaryColor,
    fontWeight: 700,
    alignSelf: 'start',
  },
  unselectedContact: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundColor: '#F5F5F5',
  },
  imageContainer: {
    display: 'flex',
    height: 'fit-content',
    width: 'fit-content',
  },
  contactList: {
    flex: 1,
    overflowY: 'hidden',
    overflowX: 'hidden',

    "& > div:last-child": {
      height: '100%',
    },
  },
});

export default styles;
